export const timeStatus = [
  'beginTime_asc',
  'beginTime_desc',
  'endTime_asc',
  'endTime_desc'
]
